import * as mutation from "./mutation-types";
import * as systemLogMutation from "@/store/system-logs/mutation-types";
import * as action from "./action-types";
import { SHOW_NOTIFICATION, HIDE_NOTIFICATION } from "@/store/notifications/mutation-types";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import { tableHelper } from "@/helpers/table.helper";
import { deepCopy, deepCopyAxiosException } from "@/store/helpers";
import axios from "axios";

export const actions = {
  async [action.LIST]({ commit, state }) {
    commit(mutation.LIST_STARTED);
    try {
      const criteria = deepCopy(state.listing.criteria);
      criteria.levyCollectionId = state.listing.levyCollectionId;
      criteria.providerId = state.listing.providerId;
      const url = tableHelper.constructUrl("/api/notices", state.listing.paging, criteria);
      const { headers, data } = await axios.get(url);
      commit(mutation.LIST_SET_CRITERIA_DESCRIPTION, tableHelper.getCriteriaInfo(headers));
      commit(mutation.LIST_SET_PAGING, tableHelper.getPagingFromHeaders(headers));
      commit(mutation.LIST_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.LIST_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.LIST_NEXT_PAGE]({ state, commit, dispatch }) {
    commit(mutation.LIST_SET_PAGING, { page: state.listing.paging.page + 1 });
    await dispatch(action.LIST);
  },
  async [action.LIST_PREVIOUS_PAGE]({ state, commit, dispatch }) {
    commit(mutation.LIST_SET_PAGING, { page: state.listing.paging.page - 1 });
    await dispatch(action.LIST);
  },

  async [action.EXPORT]({ commit, state }) {
    commit(mutation.EXPORT_STARTED);
    try {
      const criteria = deepCopy(state.listing.criteria);
      criteria.levyCollectionId = state.listing.levyCollectionId;
      criteria.providerId = state.listing.providerId;
      await axios.get(tableHelper.constructUrl("/api/exports/validate/notices", criteria));
      commit(SHOW_NOTIFICATION, "Your export will commence shortly.");
      const url = tableHelper.constructUrl(`/api/exports/notices`, criteria);
      tableHelper.downloadExportedSpreadsheet(url);
      commit(mutation.EXPORT_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.EXPORT_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.PREVIEW_SEND]({ commit }, { type, levyCollectionId, providerId }) {
    commit(mutation.PREVIEW_SEND_STARTED, { type, levyCollectionId, providerId });
    try {
      const url = tableHelper.constructUrl("/api/notices/preview", { type, levyCollectionId, providerId });
      const { data } = await axios.get(url);
      commit(mutation.PREVIEW_SEND_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.PREVIEW_SEND_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.PREVIEW_RESEND]({ commit }, noticeId) {
    commit(mutation.PREVIEW_RESEND_STARTED, noticeId);
    try {
      const url = `/api/notices/${noticeId}/preview`;
      const { data } = await axios.get(url);
      commit(mutation.PREVIEW_RESEND_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.PREVIEW_RESEND_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.RESEND]({ commit, state }) {
    commit(mutation.RESEND_STARTED);
    try {
      const { data } = await axios.post("/api/notices/resend", state.resend.data);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(mutation.STATE_UNLOAD);
      commit(mutation.RESEND_SUCCEEDED, data);
      commit(SHOW_NOTIFICATION, "Notice has been resent.");
      return true;
    } catch (e) {
      commit(mutation.RESEND_FAILED);
      commit(HIDE_NOTIFICATION);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.VIEW]({ commit }, id) {
    commit(mutation.VIEW_STARTED);
    try {
      const { data } = await axios.get(`/api/notices/${id}`);
      commit(mutation.VIEW_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.VIEW_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.GET_TIMELINE]({ commit }, { levyCollectionId, providerId }) {
    commit(mutation.GET_TIMELINE_STARTED, { levyCollectionId, providerId });
    try {
      const url = `/api/levy-collections/${levyCollectionId}/providers/${providerId}/notices-timeline`;
      const { data } = await axios.get(url);
      commit(mutation.GET_TIMELINE_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.GET_TIMELINE_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
